module.exports = __webpack_public_path__ + "static/better-guide-540w-fac3e9ce9f35f031b3e090b61f3dd990.jpg";